/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PracticeBaseService } from '../practice-base-service';
import { PracticeApiConfiguration } from '../practice-api-configuration';
import { PracticeStrictHttpResponse } from '../practice-strict-http-response';

import { encounterCompleteEncounterPost } from '../fn/encounter/encounter-complete-encounter-post';
import { EncounterCompleteEncounterPost$Params } from '../fn/encounter/encounter-complete-encounter-post';
import { EncounterDetailModel } from '../models/encounter-detail-model';
import { EncounterDetailModelSearchResultModel } from '../models/encounter-detail-model-search-result-model';
import { encounterFacilityIdEncountersPost } from '../fn/encounter/encounter-facility-id-encounters-post';
import { EncounterFacilityIdEncountersPost$Params } from '../fn/encounter/encounter-facility-id-encounters-post';
import { encounterFacilityIdEncountersPractitionerIdPatientIdPost } from '../fn/encounter/encounter-facility-id-encounters-practitioner-id-patient-id-post';
import { EncounterFacilityIdEncountersPractitionerIdPatientIdPost$Params } from '../fn/encounter/encounter-facility-id-encounters-practitioner-id-patient-id-post';
import { encounterFacilityIdEncountersPractitionerIdPost } from '../fn/encounter/encounter-facility-id-encounters-practitioner-id-post';
import { EncounterFacilityIdEncountersPractitionerIdPost$Params } from '../fn/encounter/encounter-facility-id-encounters-practitioner-id-post';
import { encounterIdGet } from '../fn/encounter/encounter-id-get';
import { EncounterIdGet$Params } from '../fn/encounter/encounter-id-get';
import { encounterManualAdjustmentTechniquesGet } from '../fn/encounter/encounter-manual-adjustment-techniques-get';
import { EncounterManualAdjustmentTechniquesGet$Params } from '../fn/encounter/encounter-manual-adjustment-techniques-get';
import { encounterNoteUpdatePost } from '../fn/encounter/encounter-note-update-post';
import { EncounterNoteUpdatePost$Params } from '../fn/encounter/encounter-note-update-post';
import { EncounterNoteUpdateResponseModel } from '../models/encounter-note-update-response-model';
import { encounterUpdateNotesPost } from '../fn/encounter/encounter-update-notes-post';
import { EncounterUpdateNotesPost$Params } from '../fn/encounter/encounter-update-notes-post';
import { ManualAdjustmentModel } from '../models/manual-adjustment-model';
import { NotesModel } from '../models/notes-model';

@Injectable({ providedIn: 'root' })
export class PracticeEncounterService extends PracticeBaseService {
  constructor(config: PracticeApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `encounterIdGet()` */
  static readonly EncounterIdGetPath = '/Encounter/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterIdGet$Response(params: EncounterIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModel>> {
    const obs = encounterIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterIdGet(params: EncounterIdGet$Params, context?: HttpContext): Observable<EncounterDetailModel> {
    const resp = this.encounterIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<EncounterDetailModel>): EncounterDetailModel => r.body)
    );
  }

  /** Path part for operation `encounterNoteUpdatePost()` */
  static readonly EncounterNoteUpdatePostPath = '/Encounter/NoteUpdate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterNoteUpdatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterNoteUpdatePost$Response(params?: EncounterNoteUpdatePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterNoteUpdateResponseModel>> {
    const obs = encounterNoteUpdatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterNoteUpdatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterNoteUpdatePost(params?: EncounterNoteUpdatePost$Params, context?: HttpContext): Observable<EncounterNoteUpdateResponseModel> {
    const resp = this.encounterNoteUpdatePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<EncounterNoteUpdateResponseModel>): EncounterNoteUpdateResponseModel => r.body)
    );
  }

  /** Path part for operation `encounterCompleteEncounterPost()` */
  static readonly EncounterCompleteEncounterPostPath = '/Encounter/CompleteEncounter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterCompleteEncounterPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterCompleteEncounterPost$Response(params?: EncounterCompleteEncounterPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModel>> {
    const obs = encounterCompleteEncounterPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterCompleteEncounterPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterCompleteEncounterPost(params?: EncounterCompleteEncounterPost$Params, context?: HttpContext): Observable<EncounterDetailModel> {
    const resp = this.encounterCompleteEncounterPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<EncounterDetailModel>): EncounterDetailModel => r.body)
    );
  }

  /** Path part for operation `encounterUpdateNotesPost()` */
  static readonly EncounterUpdateNotesPostPath = '/Encounter/UpdateNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterUpdateNotesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterUpdateNotesPost$Response(params?: EncounterUpdateNotesPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<NotesModel>> {
    const obs = encounterUpdateNotesPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterUpdateNotesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterUpdateNotesPost(params?: EncounterUpdateNotesPost$Params, context?: HttpContext): Observable<NotesModel> {
    const resp = this.encounterUpdateNotesPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<NotesModel>): NotesModel => r.body)
    );
  }

  /** Path part for operation `encounterFacilityIdEncountersPost()` */
  static readonly EncounterFacilityIdEncountersPostPath = '/Encounter/{facilityId}/Encounters';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterFacilityIdEncountersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterFacilityIdEncountersPost$Response(params: EncounterFacilityIdEncountersPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>> {
    const obs = encounterFacilityIdEncountersPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterFacilityIdEncountersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterFacilityIdEncountersPost(params: EncounterFacilityIdEncountersPost$Params, context?: HttpContext): Observable<EncounterDetailModelSearchResultModel> {
    const resp = this.encounterFacilityIdEncountersPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>): EncounterDetailModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `encounterFacilityIdEncountersPractitionerIdPost()` */
  static readonly EncounterFacilityIdEncountersPractitionerIdPostPath = '/Encounter/{facilityId}/Encounters/{practitionerId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterFacilityIdEncountersPractitionerIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterFacilityIdEncountersPractitionerIdPost$Response(params: EncounterFacilityIdEncountersPractitionerIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>> {
    const obs = encounterFacilityIdEncountersPractitionerIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterFacilityIdEncountersPractitionerIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterFacilityIdEncountersPractitionerIdPost(params: EncounterFacilityIdEncountersPractitionerIdPost$Params, context?: HttpContext): Observable<EncounterDetailModelSearchResultModel> {
    const resp = this.encounterFacilityIdEncountersPractitionerIdPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>): EncounterDetailModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `encounterFacilityIdEncountersPractitionerIdPatientIdPost()` */
  static readonly EncounterFacilityIdEncountersPractitionerIdPatientIdPostPath = '/Encounter/{facilityId}/Encounters/{practitionerId}/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterFacilityIdEncountersPractitionerIdPatientIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterFacilityIdEncountersPractitionerIdPatientIdPost$Response(params: EncounterFacilityIdEncountersPractitionerIdPatientIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>> {
    const obs = encounterFacilityIdEncountersPractitionerIdPatientIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterFacilityIdEncountersPractitionerIdPatientIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterFacilityIdEncountersPractitionerIdPatientIdPost(params: EncounterFacilityIdEncountersPractitionerIdPatientIdPost$Params, context?: HttpContext): Observable<EncounterDetailModelSearchResultModel> {
    const resp = this.encounterFacilityIdEncountersPractitionerIdPatientIdPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>): EncounterDetailModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `encounterManualAdjustmentTechniquesGet()` */
  static readonly EncounterManualAdjustmentTechniquesGetPath = '/Encounter/ManualAdjustmentTechniques';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterManualAdjustmentTechniquesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterManualAdjustmentTechniquesGet$Response(params?: EncounterManualAdjustmentTechniquesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<ManualAdjustmentModel>>> {
    const obs = encounterManualAdjustmentTechniquesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterManualAdjustmentTechniquesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterManualAdjustmentTechniquesGet(params?: EncounterManualAdjustmentTechniquesGet$Params, context?: HttpContext): Observable<Array<ManualAdjustmentModel>> {
    const resp = this.encounterManualAdjustmentTechniquesGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<ManualAdjustmentModel>>): Array<ManualAdjustmentModel> => r.body)
    );
  }

}
